import { DealEventStatus } from '@dealstack/shared/lib/backendClient';
import { DefaultTheme } from 'styled-components';

type Translate = (key: string) => string;

const STATUS_LABEL_KEY: Record<DealEventStatus, string> = {
	[DealEventStatus.COMPLETED]: 'deal_event_log.filter.status.completed',
	[DealEventStatus.IN_PROGRESS]: 'deal_event_log.filter.status.in_progress',
	[DealEventStatus.PENDING]: 'deal_event_log.filter.status.pending',
	[DealEventStatus.APPROVED]: 'deal_event_log.filter.status.approved',
	[DealEventStatus.DRAFT]: 'deal_event_log.filter.status.draft',
	[DealEventStatus.FAILED]: 'deal_event_log.filter.status.failed',
	[DealEventStatus.CANCELLED]: 'deal_event_log.filter.status.cancelled',
	[DealEventStatus.SUCCESS]: 'deal_event_log.filter.status.success',
	[DealEventStatus.SENT]: 'deal_event_log.filter.status.sent',
	[DealEventStatus.DELIVERED]: 'deal_event_log.filter.status.delivered',
	[DealEventStatus.OPENED]: 'deal_event_log.filter.status.opened',
	[DealEventStatus.READ]: 'deal_event_log.filter.status.read',
	[DealEventStatus.BOUNCED]: 'deal_event_log.filter.status.bounced',
	[DealEventStatus.WARNING]: 'deal_event_log.filter.status.warning',
	[DealEventStatus.EXPIRED]: 'deal_event_log.filter.status.expired',
	[DealEventStatus.REJECTED]: 'deal_event_log.filter.status.rejected',
};

export const getStatusLabel = (status: DealEventStatus, t: Translate): string =>
	t(STATUS_LABEL_KEY[status]);

const PROGRESSING = new Set<DealEventStatus>([
	DealEventStatus.PENDING,
	DealEventStatus.IN_PROGRESS,
	DealEventStatus.DRAFT,
	DealEventStatus.WARNING,
]);

const UNSUCCESSFUL = new Set<DealEventStatus>([
	DealEventStatus.FAILED,
	DealEventStatus.CANCELLED,
	DealEventStatus.EXPIRED,
	DealEventStatus.REJECTED,
	DealEventStatus.BOUNCED,
]);

export const getStatusColor = (status: DealEventStatus, theme: DefaultTheme): string => {
	if (PROGRESSING.has(status)) {
		return theme.v3.colors.orange[8];
	}

	if (UNSUCCESSFUL.has(status)) {
		return theme.v3.colors.red[8];
	}

	return theme.v3.colors.teal[8];
};
